import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/img/tap-icon.svg'


const _hoisted_1 = {
  key: 0,
  class: "flip-button"
}
const _hoisted_2 = {
  key: 1,
  class: "vertical-flip-button"
}
const _hoisted_3 = {
  key: 2,
  class: "split-button"
}
const _hoisted_4 = {
  key: 3,
  class: "split-left-button"
}
const _hoisted_5 = { class: "inner-card-image" }
const _hoisted_6 = {
  key: 0,
  class: "pending-alt-card-text"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "pending-alt-card-text"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "flip-back"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

import CardText from "./CardText.vue";
import CardPlaceholder from "./CardPlaceholder.vue";
import ClazyLoad from "./../vue-clazy-load.vue";

import { computed } from "vue";
import { Language } from "@/Types";
import { Card, CardFace } from "@/CardTypes";
import { useCardCache, ScryfallCard, isReady, ScryfallCardFace, CardCacheEntry } from "../vueCardCache";


export default /*@__PURE__*/_defineComponent({
  __name: 'CardImage',
  props: {
    card: {},
    language: {},
    lazyLoad: { type: Boolean, default: false },
    fixedLayout: { type: Boolean, default: false },
    displayCardText: { type: Boolean, default: false },
    renderCommonBackside: { type: Boolean, default: true }
  },
  setup(__props: any) {

const { cardCache } = useCardCache();

const props = __props;
const imageURI = computed(() => {
	if (props.language in props.card.image_uris) return props.card.image_uris[props.language];
	return props.card.image_uris["en"];
});
const hasBack = computed(() => {
	return props.card.back !== null && props.card.back !== undefined;
});
const backImageURI = computed(() => {
	if (!hasBack.value) return undefined;
	return props.language in props.card.back!.image_uris
		? props.card.back?.image_uris[props.language]
		: props.card.back?.image_uris["en"];
});
const cardAdditionalData = computed(() => {
	if (!props.displayCardText) return false; // Don't send the requests automatically
	if (props.card.is_custom) return { ...props.card, status: "custom" } as Card & { status: "custom" };
	return cardCache.get(props.card.id);
});

const cardFrontAdditionalData = computed(
	(): CardCacheEntry | ScryfallCard | ScryfallCardFace | CardFace | undefined => {
		const data = cardAdditionalData.value;
		if (!data) return undefined;
		if (data.status === "custom") return data;
		if (isReady(data) && data.card_faces) return data.card_faces[0];
		else return data;
	}
);
const cardBackAdditionalData = computed((): CardCacheEntry | ScryfallCard | ScryfallCardFace | CardFace | undefined => {
	const data = cardAdditionalData.value;
	if (!data) return undefined;
	if (data.status === "custom") return data.back;
	if (isReady(data) && data.card_faces) return data.card_faces[1];
	else return undefined;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!

  return (!__props.fixedLayout)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["card-image", { 'has-back': hasBack.value }])
      }, [
        (hasBack.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_font_awesome_layers, null, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-sync",
                    class: "flip-icon",
                    transform: "grow-2",
                    size: "lg",
                    style: {"color":"black"}
                  }),
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-sync",
                    class: "flip-icon",
                    size: "lg"
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true),
        (__props.card.layout === 'flip')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_font_awesome_layers, null, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-sync",
                    class: "vertical-flip-icon",
                    transform: "grow-2",
                    size: "lg",
                    style: {"color":"black"}
                  }),
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-sync",
                    class: "vertical-flip-icon",
                    size: "lg"
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true),
        (__props.card.layout === 'split' || __props.card.type.includes('Battle'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                class: "split-icon"
              }, null, -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true),
        (__props.card.layout === 'split-left')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_0,
                class: "split-left-icon"
              }, null, -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'flip-container': hasBack.value || __props.renderCommonBackside })
          }, [
            _createVNode(ClazyLoad, {
              ratio: 0,
              margin: "200px",
              src: imageURI.value,
              loadingClass: "card-loading",
              forceLoad: !__props.lazyLoad,
              class: _normalizeClass({ 'flip-front': hasBack.value || __props.renderCommonBackside })
            }, {
              placeholder: _withCtx(() => [
                _createVNode(CardPlaceholder, { card: __props.card }, null, 8 /* PROPS */, ["card"])
              ]),
              default: _withCtx(() => [
                (cardAdditionalData.value && __props.displayCardText)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (cardAdditionalData.value.status === 'pending')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-spinner",
                              spin: ""
                            })
                          ]))
                        : (_openBlock(), _createBlock(CardText, {
                            key: 1,
                            card: cardFrontAdditionalData.value!
                          }, null, 8 /* PROPS */, ["card"]))
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("img", {
                  class: "front-image",
                  src: imageURI.value
                }, null, 8 /* PROPS */, _hoisted_7)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["src", "forceLoad", "class"]),
            (hasBack.value)
              ? (_openBlock(), _createBlock(ClazyLoad, {
                  key: 0,
                  ratio: 0,
                  margin: "200px",
                  src: backImageURI.value!,
                  loadingClass: "card-loading",
                  class: "flip-back",
                  forceLoad: !__props.lazyLoad
                }, {
                  placeholder: _withCtx(() => [
                    _createVNode(CardPlaceholder, {
                      card: __props.card.back
                    }, null, 8 /* PROPS */, ["card"])
                  ]),
                  default: _withCtx(() => [
                    (cardAdditionalData.value && __props.displayCardText)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (cardAdditionalData.value.status === 'pending')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-spinner",
                                  spin: ""
                                })
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (hasBack.value && cardBackAdditionalData.value)
                                  ? (_openBlock(), _createBlock(CardText, {
                                      key: 0,
                                      card: cardBackAdditionalData.value
                                    }, null, 8 /* PROPS */, ["card"]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("img", {
                      class: "back-image",
                      src: backImageURI.value
                    }, null, 8 /* PROPS */, _hoisted_9)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["src", "forceLoad"]))
              : (__props.renderCommonBackside)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(CardPlaceholder, { card: undefined })
                  ]))
                : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ])
      ], 2 /* CLASS */))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["fixed-layout", {
			'layout-back': hasBack.value,
			'layout-flip': __props.card.layout === 'flip',
			'layout-split': __props.card.layout === 'split',
			'layout-split-left': __props.card.layout === 'split-left',
		}])
      }, [
        _createVNode(ClazyLoad, {
          src: imageURI.value,
          loadingClass: "card-loading",
          forceLoad: !__props.lazyLoad,
          class: _normalizeClass(["card-individual-image", {
				'split-and-back':
					__props.card.type.includes('Battle') ||
					((__props.card.layout === 'split' || __props.card.layout === 'split-left') && hasBack.value),
				left: __props.card.layout === 'split-left',
			}])
        }, {
          placeholder: _withCtx(() => [
            _createVNode(CardPlaceholder, { card: __props.card }, null, 8 /* PROPS */, ["card"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("img", { src: imageURI.value }, null, 8 /* PROPS */, _hoisted_11),
            (__props.displayCardText)
              ? (_openBlock(), _createBlock(CardText, {
                  key: 0,
                  card: cardFrontAdditionalData.value!
                }, null, 8 /* PROPS */, ["card"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["src", "forceLoad", "class"]),
        (hasBack.value)
          ? (_openBlock(), _createBlock(ClazyLoad, {
              key: 0,
              src: backImageURI.value!,
              loadingClass: "card-loading",
              forceLoad: !__props.lazyLoad,
              class: _normalizeClass(["card-individual-image", {
				'split-back': __props.card.back?.layout === 'split' || __props.card.back?.layout === 'split-left',
				left: __props.card.back?.layout === 'split-left',
			}])
            }, {
              placeholder: _withCtx(() => [
                _createVNode(CardPlaceholder, {
                  card: __props.card.back
                }, null, 8 /* PROPS */, ["card"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("img", { src: backImageURI.value }, null, 8 /* PROPS */, _hoisted_12),
                (__props.displayCardText)
                  ? (_openBlock(), _createBlock(CardText, {
                      key: 0,
                      card: cardBackAdditionalData.value!
                    }, null, 8 /* PROPS */, ["card"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["src", "forceLoad", "class"]))
          : _createCommentVNode("v-if", true),
        (__props.card.layout === 'flip')
          ? (_openBlock(), _createBlock(ClazyLoad, {
              key: 1,
              src: imageURI.value,
              loadingClass: "card-loading",
              forceLoad: !__props.lazyLoad,
              class: "card-individual-image"
            }, {
              placeholder: _withCtx(() => [
                _createVNode(CardPlaceholder, { card: __props.card }, null, 8 /* PROPS */, ["card"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: imageURI.value,
                  style: {"transform":"rotate(180deg)"}
                }, null, 8 /* PROPS */, _hoisted_13),
                (__props.displayCardText)
                  ? (_openBlock(), _createBlock(CardText, {
                      key: 0,
                      card: cardBackAdditionalData.value!
                    }, null, 8 /* PROPS */, ["card"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["src", "forceLoad"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
}
}

})